module.exports = __webpack_public_path__ + "static/projects-2-4bf1f2ec323d887f04522469695815c7.jpg";